import { BookOpen, Download, ExternalLink, Quote } from "lucide-react";

const publications = [
  {
    number: "24",
    title: "Enhancing Autonomous Navigation: Real-Time LIDAR Detection of Roads and Sidewalks in ROS 2",
    date: "31 October 2025",
    doi: "10.3390/engproc2025113024",
    page: "https://www.mdpi.com/2673-4591/113/1/24",
    pdf: "https://www.mdpi.com/2673-4591/113/1/24/pdf",
    authors: "Barham J. B. Farraj, Abdelrahman Alabdallah, Miklós Unger, and Ernő Horváth",
    abstract: "A ROS 2-integrated LiDAR approach for detecting roads and sidewalks in real time, designed to address the computational efficiency and precision demands of urban autonomous navigation.",
    bibtex: "@article{farraj2025lidar, title={Enhancing Autonomous Navigation: Real-Time LIDAR Detection of Roads and Sidewalks in ROS 2}, author={Farraj, Barham Jeries Barham and Alabdallah, Abdelrahman and Unger, Miklós and Horváth, Ernő}, journal={Engineering Proceedings}, volume={113}, number={1}, pages={24}, year={2025}, doi={10.3390/engproc2025113024}}",
  },
  {
    number: "09",
    title: "Evaluation of SLAM Methods for Small-Scale Autonomous Racing Vehicles",
    date: "28 October 2025",
    doi: "10.3390/engproc2025113009",
    page: "https://www.mdpi.com/2673-4591/113/1/9",
    pdf: "https://www.mdpi.com/2673-4591/113/1/9/pdf",
    authors: "Rudolf Krecht, Abdelrahman M. A. Alabdallah, and Barham J. B. Farraj",
    abstract: "A real-world comparison of SLAM Toolbox and Cartographer for small-scale autonomous racing, using 2D laser-scanner and odometry data with quantitative map evaluation against track ground truth.",
    bibtex: "@article{krecht2025slam, title={Evaluation of SLAM Methods for Small-Scale Autonomous Racing Vehicles}, author={Krecht, Rudolf and Alabdallah, Abdelrahman Mutaz A. and Farraj, Barham Jeries B.}, journal={Engineering Proceedings}, volume={113}, number={1}, pages={9}, year={2025}, doi={10.3390/engproc2025113009}}",
  },
  {
    number: "13",
    title: "ROS 2-Based Framework for Semi-Automatic Vector Map Creation in Autonomous Driving Systems",
    date: "28 October 2025",
    doi: "10.3390/engproc2025113013",
    page: "https://www.mdpi.com/2673-4591/113/1/13",
    pdf: "https://www.mdpi.com/2673-4591/113/1/13/pdf",
    authors: "Abdelrahman Alabdallah, Barham J. B. Farraj, and Ernő Horváth",
    abstract: "A ROS 2 framework that reduces the manual effort required to create Lanelet2-style high-definition vector maps for localization, planning, and autonomous-driving workflows.",
    bibtex: "@article{alabdallah2025vector, title={ROS 2-Based Framework for Semi-Automatic Vector Map Creation in Autonomous Driving Systems}, author={Alabdallah, Abdelrahman and Farraj, Barham Jeries Barham and Horváth, Ernő}, journal={Engineering Proceedings}, volume={113}, number={1}, pages={13}, year={2025}, doi={10.3390/engproc2025113013}}",
  },
];

export default function Publications() {
  const downloadBibtex = (publication) => {
    const blob = new Blob([publication.bibtex], { type: "application/x-bibtex" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${publication.doi.replaceAll("/", "-")}.bib`;
    anchor.click();
    URL.revokeObjectURL(url);
  };

  return (
    <section id="publications" className="publications-section">
      <div className="container" data-aos="fade-up">
        <div className="section-title section-title-left">
          <span className="section-index">05 — Research</span>
          <h2>Peer-reviewed work in autonomous systems</h2>
          <p>Published in the open-access <em>Engineering Proceedings</em>, volume 113.</p>
        </div>
        <div className="publication-list">
          {publications.map((publication) => (
            <article className="research-paper" key={publication.doi}>
              <div className="paper-meta">
                <span className="publisher-badge"><BookOpen size={16} /> MDPI</span>
                <strong>2025</strong>
                <span>Engineering Proceedings 113(1), {publication.number}</span>
              </div>
              <div className="paper-main">
                <h3>{publication.title}</h3>
                <p className="paper-authors">{publication.authors}</p>
                <div className="paper-abstract"><Quote size={20} /><p>{publication.abstract}</p></div>
                <p className="paper-doi">DOI <a href={`https://doi.org/${publication.doi}`} target="_blank" rel="noopener noreferrer">{publication.doi}</a> · Published {publication.date}</p>
                <div className="paper-actions">
                  <a href={publication.page} target="_blank" rel="noopener noreferrer"><ExternalLink size={16} /> Full article</a>
                  <a href={publication.pdf} target="_blank" rel="noopener noreferrer"><Download size={16} /> PDF</a>
                  <button type="button" onClick={() => downloadBibtex(publication)}><Download size={16} /> BibTeX</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
